import { useState, useEffect, useRef } from 'react';
import Util from 'lib/util.js';
import Storage from 'services/storage2';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import CompanyService from 'services/company2';
/**
 * 列表页自定义Hooks
 *
 * @param props
 * @param config
 * @returns
 */
export default function useList(props: any, config: any) {
  const [companyCode, setCompanyCode] = useState<string | null>(null);
  const [companyName, setCompanyName] = useState<string | null>(null);
  const [inited, setInited] = useState(false); //初始化顶部菜单/搜索栏
  const [error, setError] = useState<any>(null);
  const [dataError, setDataError] = useState<any>(null);
  const [list, setList] = useState<any[]>([]);
  const [count, setCount] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [showLoading, setShowLoading] = useState(true);
  const [updateTs, setUpdateTs] = useState(0);
  // 以下状态需要记忆，为方便写缓存时判断是否初始值，故使用 undefined 初始化
  const [searchKey, setSearchKey] = useState<string | undefined>(undefined);
  const [currentTab, setCurrentTab] = useState<number | undefined>(undefined); //当前页签
  const [listField, setListField] = useState<string>('list'); //当前列表参数
  const [totalField, setTotalField] = useState<string>('total'); //当前列表总数量参数

  let objHistoryState: any = Storage.getItem('historyState') || {};
  let urlHashKey: string = Util.getHashKey(props.match.url);
  let historyState: any = { searchKey: '' };
  let isPurchase = props.type ? props.type.indexOf('purchase') !== -1 : true; // 从路由读取是否采购方，在采购方和供应方共用列表时必传。默认true
  let searchQueries = {}; //列表请求参数
  let pageResolveLoading: Function = () => {}; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
  let init: Function = () => {};
  let getCount: Function = () => {};
  let beforeSearch: Function = () => {};
  let search: Function = () => {};
  let listTransform: Function = () => {};
  let saveHistorySatate: Function = () => {};

  //创建实例，用于储存非状态可变值
  let instant = useRef({
    isPurchase,
    objHistoryState,
    urlHashKey,
    historyState,
    pageResolveLoading,
    init,
    getCount,
    beforeSearch,
    search,
    searchQueries,
    listTransform,
    saveHistorySatate
  });
  let self = instant.current;

  self.init = function () {
    //获取页面历史状态，用于详情页返回列表（页面页签等）
    self.historyState = self.objHistoryState[self.urlHashKey] || {};
    setSearchKey(self.historyState.searchKey);

    if (self.historyState.currentTab > 0) {
      handleTab(self.historyState.currentTab);
    } else {
      handleTab(0);
    }

    if (self.historyState.searchQueries) {
      self.searchQueries = self.historyState.searchQueries;
    }

    User.init().then(response => {
      if (response.success) {
        let code = User.getCompanyCode();
        let companyInfo = User.getCompanyInfo(code);
        setInited(true);
        setCompanyCode(code);
        if (companyInfo) {
          setCompanyName(companyInfo.companyName);
        }
      } else {
        setError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
  };

  self.getCount = function (params?: any) {
    if (!companyCode || !config.countApi) {
      return;
    }
    let countApiParams = config.countApiParams || {};
    let postbody = {
      ...countApiParams,
      ...params,
      apiPath: config.countApi,
      companyCode
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        config.countTransform(response.data);
      }
    });
  };

  self.beforeSearch = async function () {};

  self.search = async function (refresh?, inputPageNum?) {
    if (!companyCode) {
      return;
    }
    await self.beforeSearch();
    let postbody = {
      apiPath: config.apiPath,
      ascOrDesc: 'desc',
      companyCode,
      ...self.searchQueries,
      orderProperty: config.orderProperty,
      pageNum: inputPageNum || pageNum,
      pageSize: 10,
      searchKey: searchKey
    };

    let arrPromise = [Http.post('/api/cloudCenter', postbody)];
    if (Array.isArray(config.arrEnumField)) {
      config.arrEnumField.forEach((item: any) => {
        arrPromise.push(EnumService.getList(item.mainKey));
      });
    }

    setDataError(null);
    await Promise.all(arrPromise).then(async arrResponse => {
      let response = arrResponse[0];

      setShowLoading(false);
      if (response.success) {
        let arr: any[];
        let data = listField ? response.data[listField] : response.data;

        if (!Array.isArray(data)) {
          return;
        }

        if (refresh) {
          //删除等会导致列表数量发生变化的操作
          arr = data;
        } else {
          arr = list.concat(data);
        }

        for (let item of arr) {
          //枚举转换
          if (
            Array.isArray(config.arrEnumField) &&
            config.arrEnumField.length > 0
          ) {
            for (let conf of config.arrEnumField) {
              await EnumService.getValue(conf.mainKey, item[conf.subKey]).then(
                value => {
                  item[conf.value] = value;
                }
              );
            }
          }

          //小数位获取
          let dpCompanyCode =
            ['customerOrder', 'sale'].includes(props.type) || !isPurchase
              ? item.customerCode
              : companyCode;
          await CompanyService.getDecimalPlaceByCodes(dpCompanyCode).then(
            (rs: any) => {
              for (let code in rs) {
                item[code] = rs[code];
              }
            }
          );
        }
        setTotal(response.data[totalField]);

        await self.listTransform(arr);
        setList(arr);
        if (inputPageNum) {
          setPageNum(inputPageNum + 1);
        } else {
          setPageNum(pageNum + 1);
        }

        self.pageResolveLoading();
        self.saveHistorySatate();
        forceUpdate();
      } else {
        setDataError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
  };

  /**
   * 保存搜索历史
   *
   */
  self.saveHistorySatate = function () {
    if (config.needSessionStorage) {
      self.historyState.searchQueries = self.searchQueries;
      self.objHistoryState[self.urlHashKey] = self.historyState;
      Storage.setItem('historyState', self.objHistoryState);
    }
  };

  //记忆搜索key
  useEffect(() => {
    if (searchKey !== undefined) {
      self.historyState.searchKey = searchKey;
      self.objHistoryState[self.urlHashKey] = self.historyState;
      Storage.setItem('historyState', self.objHistoryState);
    }
  }, [searchKey, self]);

  //记忆页签
  useEffect(() => {
    if (currentTab !== undefined) {
      self.historyState.currentTab = currentTab;
      self.objHistoryState[self.urlHashKey] = self.historyState;
      Storage.setItem('historyState', self.objHistoryState);
    }
  }, [currentTab, self]);

  //强制重新渲染
  function forceUpdate() {
    setUpdateTs(Date.now());
  }

  //搜索关键字改变
  function handleChange(text: string, e: any) {
    e.preventDefault();
    setSearchKey(text);
    handleReset();
  }

  //清除搜索关键字
  function handleClear() {
    if (searchKey === '') {
      return;
    }
    setSearchKey('');
    handleReset();
  }

  //切换页签
  function handleTab(index: number) {
    handleReset();
    setCurrentTab(index);
  }

  //重置列表
  function handleReset() {
    setList([]);
    setPageNum(1);
    setShowLoading(false);
    self.pageResolveLoading();
  }

  return {
    companyCode,
    setCompanyCode,
    companyName,
    setCompanyName,
    searchKey,
    setSearchKey,
    inited,
    setInited,
    error,
    setError,
    dataError,
    setDataError,
    currentTab,
    setCurrentTab,
    count,
    setCount,
    pageNum,
    setPageNum,
    total,
    setTotal,
    showLoading,
    setShowLoading,
    list,
    setList,
    forceUpdate,
    handleChange,
    handleClear,
    handleTab,
    handleReset,
    updateTs,
    setUpdateTs,
    setListField,
    setTotalField,
    self
  };
}
